/** Wins as the ladder counts them, a draw half of one (D-46): 2, 2½, ½. */
export function formatWins(wins: number): string {
  const whole = Math.floor(wins + 1e-9);
  if (wins - whole < 0.25) return String(whole);
  return whole > 0 ? `${whole}½` : '½';
}
